/**
 * set input field only number
 * @param {Text} e 
 */
export function setOnlyNumber(e) {
    e.currentTarget.value = e.currentTarget.value.replace(/\D/g, '')
}

/**
 * capitalize function
 * @param {String} str 
 * @returns String
 */
export function Capitalize(str = '') {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
}

/**
 * 
 * @param {date/str} val 
 * @returns String
 */
export function DateIndo(val) {
    var date = new Date(val);
    var tahun = date.getFullYear();
    var bulan = date.getMonth();
    var tanggal = date.getDate();
    switch (bulan) {
        case 1: bulan = "Februari"; break;
        case 2: bulan = "Maret"; break;
        case 3: bulan = "April"; break;
        case 4: bulan = "Mei"; break;
        case 5: bulan = "Juni"; break;
        case 6: bulan = "Juli"; break;
        case 7: bulan = "Agustus"; break;
        case 8: bulan = "September"; break;
        case 9: bulan = "Oktober"; break;
        case 10: bulan = "November"; break;
        case 11: bulan = "Desember"; break;
        default: bulan = 'Januari';
    }
    var result = tanggal + " " + bulan + " " + tahun;

    return result;
};
